"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".resultContent_a6ff4bcf{display:table-row}.resultContent_a6ff4bcf .resultItem_a6ff4bcf{display:table-cell;vertical-align:bottom}.peoplePickerPersona_a6ff4bcf{width:180px}.peoplePickerPersona_a6ff4bcf .ms-Persona-details{width:100%}.peoplePicker_a6ff4bcf .ms-BasePicker-text{min-height:40px}.peoplePickerPersonaContent_a6ff4bcf{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:7px 12px}\n" }]);
exports.resultContent = "resultContent_a6ff4bcf";
exports.resultItem = "resultItem_a6ff4bcf";
exports.peoplePickerPersona = "peoplePickerPersona_a6ff4bcf";
exports.peoplePicker = "peoplePicker_a6ff4bcf";
exports.peoplePickerPersonaContent = "peoplePickerPersonaContent_a6ff4bcf";
//# sourceMappingURL=PeoplePicker.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/FloatingPicker/PeoplePicker/PeoplePicker.scss.js
// module id = 417
// module chunks = 0